<template>
  <el-dialog title="编辑规格模板" :visible.sync="visible" width="800px" :top="200">
    <div class="sort-row">
      <div class="sort-title">规格名：{{ row.specificationName || '' }}</div>
      <div class="sort-title">规格值（可拖拽排序）</div>
    </div>
    <SortBlock v-if="specificationValue.length > 0" v-model="specificationValue" />
    <div v-if="specificationValue.length < 50" class="add-row">
      <el-button class="addBtn" v-if="!isAddMode" type="link" icon="el-icon-circle-plus-outline" @click="addClick">添加</el-button>
      <el-input
        v-else
        style="width: 120px"
        ref="newItemValue"
        v-model="newItemValue"
        @blur="newItemValueBlur"
        @keyup.enter.native="newItemValueEnter"
      ></el-input>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="handleSave">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
// 常用规格编辑弹窗
import SortBlock from './SortBlock.vue';
import { editUsualSpecification } from '@/servers/prod/center/index.js';
export default {
  components: {
    SortBlock,
  },
  data() {
    return {
      visible: false,
      row: {},
      saveFn: null,
      specificationValue: [],
      isAddMode: false,
      newItemValue: '',
    };
  },
  watch: {
    visible(v) {
      if (!v) {
        this.specificationValue = [];
        this.isAddMode = false;
        this.newItemValue = '';
      }
    },
  },
  methods: {
    async method_open(row = {}, saveFn) {
      this.row = row || {};
      this.saveFn = saveFn
      this.visible = true;
      this.specificationValue = row.specificationValue ? row.specificationValue.split(',') : [];
    },
    addClick() {
      this.isAddMode = true;
      this.$nextTick(() => {
        this.$refs.newItemValue.focus();
      });
    },
    newItemValueEnter() {
      if (!this.newItemValue) {
        this.isAddMode = false;
        return;
      }
      if (this.specificationValue.includes(this.newItemValue)) {
        this.$message.error('请勿输入重复规格值');
        return;
      }
      this.specificationValue.push(this.newItemValue);
      this.newItemValue = '';
    },
    newItemValueBlur() {
      if (this.newItemValue) {
        if (this.specificationValue.includes(this.newItemValue)) {
          this.$message.error('请勿输入重复规格值');
          return;
        }
        this.specificationValue.push(this.newItemValue);
      }
      this.newItemValue = '';
      this.isAddMode = false;
    },
    async handleSave() {
      const res = await editUsualSpecification({
        id: this.row.id,
        specificationName: this.row.specificationName,
        specificationValue: this.specificationValue.join(','),
      });
      this.saveFn && this.saveFn()
      if (res) {
        this.visible = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.sort-title {
  font-size: 14px;
  flex: 1;
  & + & {
    margin-top: 12px;
  }
}
.sort-row {
  margin: 10px 0;
  display: flex;
  flex-direction: column;
}
.addBtn {
  padding-left: 0;
  ::v-deep i {
    line-height: 16px;
    margin-top: -2px;
  }
}
</style>